import type { ReactNode } from 'react'
import { Icon } from '../components/Icon'
import { useHasPermission } from './permissions'

/** Route guard: renders an access-denied page when the session lacks the permission. */
export function RequirePermission({ perm, children }: { perm: string; children: ReactNode }) {
  const ok = useHasPermission(perm)
  if (ok) return <>{children}</>
  return (
    <div className="page">
      <div className="denied">
        <div className="mark">
          <Icon name="lock" size={24} />
        </div>
        <h2 style={{ margin: 0 }}>Access denied</h2>
        <p className="muted">You don’t have permission to view this screen. Contact a System Administrator if you need access.</p>
      </div>
    </div>
  )
}
